import { LayerData } from 'data/FlyerData';
import { PlatformType } from 'data/PlatformType';
import { MuteMotionSource } from 'motion/MuteMotionSource';
import { Middleware } from 'redux';
import RootState from 'state/RootState';
import * as Actions from '../actions';
import { isTemplateAsset } from 'utils/S3Utils';
import FlyerState from 'state/FlyerState';

const layersCache: Record<string, string> = {};
let motionSourceCache: string | undefined = undefined;
/* const flyerCache: string = '';
motionSource?: MotionSourceData;
  captions: CaptionsToken[] | null;
  captionsLanguageCode: string | null;
  */

let timeoutID = 0;
let isReady = false;

const getStorableMotionSource = (flyer: FlyerState): Object | undefined => {
  const { motionSource, soundtrack } = flyer;
  if (motionSource === soundtrack) {
    // store url only
    if (soundtrack.url && isTemplateAsset(soundtrack.url)) {
      return {
        audioUrl: soundtrack.url
      };
    }
  } else if (soundtrack !== null) {
    // store both
    const result: any = (motionSource as MuteMotionSource).asData();
    if (soundtrack.url && isTemplateAsset(soundtrack.url)) {
      result.audioUrl = soundtrack.url;
    }
    return result;
  } else {
    // store muted motion only
    return (motionSource as MuteMotionSource).asData();
  }
  return undefined;
};

export const cacheFigmaLayers: Middleware =
  (store: any) => (next: Function) => (action: any) => {
    next(action);

    const { flyer, app } = store.getState() as RootState;

    // console.log('cacheFigmaLayers', app.platform);

    if (app.platform !== PlatformType.Figma) {
      return;
    }

    window.clearTimeout(timeoutID);
    if (isReady) {
      timeoutID = window.setTimeout(() => {
        // console.log('SAVE FIGMA STATE');
        const {
          flyer: { layers }
        } = store.getState() as RootState;
        layers.forEach(l => {
          const layerData = l.toObject() as Partial<LayerData>;
          delete layerData.frames;
          const dataStr = JSON.stringify(layerData);
          if (layersCache[l.id] !== dataStr) {
            // console.log(`Save state for layer ${l.id}`);
            parent?.postMessage({ type: 'cacheFigmaLayer', layerData }, '*');
          }
          layersCache[l.id] = dataStr;
        });
        const sourceData = getStorableMotionSource(flyer);
        const newSourceStr = JSON.stringify(sourceData);
        if (motionSourceCache !== newSourceStr) {
          parent?.postMessage({ type: 'cacheFigmaMotion', sourceData }, '*');
          motionSourceCache = newSourceStr;
        }
      }, 1000);
    }

    if (action.type === Actions.ADDED_FIGMA_LAYERS) {
      // console.log('INITIALIZE FIGMA CACHE', flyer.motionSource);
      flyer.layers.forEach(l => {
        const layerData = l.toObject() as Partial<LayerData>;
        delete layerData.frames;
        const dataStr = JSON.stringify(layerData);
        layersCache[l.id] = dataStr;
      });
      motionSourceCache = JSON.stringify(getStorableMotionSource(flyer));
      isReady = true;
    }
  };



// WEBPACK FOOTER //
// ./src/state/side-effects/cacheFigmaLayers.ts